// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.international-icon[data-v-1fea40b8] {\n    font-size: 20px;\n    cursor: pointer;\n    vertical-align: -5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
